var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrugs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drugs 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.9844 5.33594H16.0078V7.64844H23.9844V5.33594Z",
    fill: "#334A56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.0078 6.82031H16.9844C13.0078 6.82031 9.78125 10.0469 9.78125 14.0234V36.2812C9.78125 38.25 11.375 39.8438 13.3438 39.8438H26.6406C28.6094 39.8438 30.2031 38.25 30.2031 36.2812V14.0234C30.2109 10.0469 26.9922 6.82031 23.0078 6.82031Z",
    fill: "#445C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.0078 6.82031H16.9844C13.0078 6.82031 9.78125 10.0469 9.78125 14.0234V14.6562C9.78125 10.6797 13.0078 7.45312 16.9844 7.45312H23.0078C26.9844 7.45312 30.2109 10.6797 30.2109 14.6562V14.0234C30.2109 10.0469 26.9922 6.82031 23.0078 6.82031Z",
    fill: "#57717F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.3437 0.15625H16.6562C16.1719 0.15625 15.7812 0.546875 15.7812 1.03125V5.33594H24.2188V1.03125C24.2188 0.546875 23.8281 0.15625 23.3437 0.15625Z",
    fill: "#EFF3F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M30.2109 14.4922H13.0234V34.9844H30.2109V14.4922Z",
    fill: "#5AC8AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M30.2109 14.4922H13.0234V15.3047H30.2109V14.4922Z",
    fill: "#6AD3B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M30.2109 20.125C28.9453 18.7109 27.1094 17.8203 25.0625 17.8203C21.2422 17.8203 18.1484 20.9141 18.1484 24.7344C18.1484 28.5547 21.2422 31.6484 25.0625 31.6484C27.1094 31.6484 28.9453 30.7578 30.2109 29.3438V20.125Z",
    fill: "#EFF3F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M30.2109 23.1641H26.8984V19.4375H23.7578V23.1641H20.0312V26.3047H23.7578V30.0312H26.8984V26.3047H30.2109V23.1641Z",
    fill: "#F1786B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrugs);
export default __webpack_public_path__ + "static/media/drugs.5803832b006f172c7c34ea7059ce3309.svg";
export { ForwardRef as ReactComponent };